import { useSuspenseQuery } from '@apollo/client/react';
import { Space } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import events from '@guuru/events-web';
import ExpertFeedbackAvatar from '../../ExpertFeedbackAvatar';
import ChatThanks from '../ChatThanks';
import FeedbackForm from './FeedbackForm';
import FeedbackHeadline from './FeedbackHealine';
import GET_CHAT_FEEDBACK_FORM_INFO from './queries/GetChatFeedbackFormInfo';

const ContentWrapper = styled(Space)`
  padding-left: 15px;
  padding-right: 15px;
  text-align: center;
  margin-bottom: 40px;
  flex-direction: column;
`;

const ChatRequestFeedback = function ({ chatId }) {
  const { useTrackEventOnce, requestFeedback } = events;
  const {
    data: { chat: { rating, expert, feedbackRequestTopics } = {} } = {},
  } = useSuspenseQuery(GET_CHAT_FEEDBACK_FORM_INFO, {
    variables: { id: chatId },
  });

  useTrackEventOnce(() => requestFeedback(), [chatId]);

  if (!feedbackRequestTopics) {
    return <ChatThanks chatId={chatId} readOnly />;
  }

  return (
    <ContentWrapper aria-label="Chat feedback section">
      <Space orientation="vertical" size={25}>
        <ExpertFeedbackAvatar expertPhoto={expert?.photoUrl} />
        <FeedbackHeadline expertName={expert?.name} rating={rating} />
      </Space>
      <FeedbackForm chatId={chatId} topics={feedbackRequestTopics} />
    </ContentWrapper>
  );
};

ChatRequestFeedback.propTypes = {
  chatId: PropTypes.string.isRequired,
};

export default ChatRequestFeedback;
